import { render, staticRenderFns } from "./EditModifiers.vue?vue&type=template&id=ad99ba7c&"
import script from "./EditModifiers.vue?vue&type=script&lang=js&"
export * from "./EditModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports